import React from 'react';
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { Info } from '@phosphor-icons/react';
import { CustomIcon } from '../CustomIcon/CustomIcon.component';
import * as S from './Premises.styles'

export interface PremisesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PremisesModal({ isOpen, onClose }: PremisesModalProps) {
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent p="24px" minWidth={'960px'}>
        <ModalHeader p='0'>
          <CustomIcon
            icon={Info}
            color="#B3B3B3"
            boxSize={5}
            $bgColor="#F2F4F7"
            $borderColor="#F9FAFB"
            $isRounded
          />
          <ModalCloseButton top="32px" right="16px" />
        </ModalHeader>
        <ModalBody p="0" display="flex" flexDirection="column" gap="24px" textAlign={'justify'} marginTop='20px'>
          <Flex flexDirection={'column'}>
            <Text color="#101828" fontSize="18px" fontWeight="600">
              Premissas
            </Text>
            <Text color="#667085" fontSize="14px">
              Segue abaixo a indicação de quais premissas foram utilizadas para o cálculo
              quantitativo apresentado.
            </Text>
          </Flex>
          <Flex flexDirection={'column'}>
            <Text color="#101828" fontSize="14px" fontWeight="600">
              Normas utilizadas
            </Text>
            <Text color="#667085" fontSize="14px">
              NBR 8800/2008 - Projeto de estrutura de aço e de estrutura mista de aço e concreto de
              edifícios quantitativo apresentado.
            </Text>
            <Text color="#667085" fontSize="14px">
              NBR 6123/1988 - Forças devidas ao vento em edificações.
            </Text>
          </Flex>
          <Flex flexDirection={'column'}>
            <Text color="#101828" fontSize="14px" fontWeight="600">
              Sistema estrutural
            </Text>
            <Text color="#667085" fontSize="14px">
              Transversal - pórticos rígidos com Perfis Estruturais Gerdau e bases engastadas.
            </Text>
            <Text color="#667085" fontSize="14px">
              Longitudinal - pórticos contraventados verticalmente com bases rotuladas.
            </Text>
            <Text color="#667085" fontSize="14px">
              Inclinação da cobertura de 10% (5,71º)
            </Text>
          </Flex>
          <Flex flexDirection={'column'}>
            <Text color="#101828" fontSize="14px" fontWeight="600">
              Tipo de aço
            </Text>
            <Text color="#667085" fontSize="14px">
              Todos os cálculos demonstrados neste manual consideram o uso de Perfis Estruturais Gerdau em aço ASTM A 572 Grau 50, com Fʏ>345 Mpa. 
            </Text>
          </Flex>
          <Flex flexDirection={'column'}>
            <Text color="#101828" fontSize="14px" fontWeight="600">
              Deslocamentos máximos
            </Text>
            <Text color="#667085" fontSize="14px">
              Verticais - L/250
            </Text>
            <Text color="#667085" fontSize="14px">
              Horizontais - H/300
            </Text>
            <Text color="#667085" fontSize="14px">
              Para terças de coberturas - L/180
            </Text>
          </Flex>
          <Flex flexDirection={'column'}>
            <Text color="#101828" fontSize="14px" fontWeight="600">
              Ações permanentes
            </Text>
            <Text color="#667085" fontSize="14px">
              Peso próprio das estruturas metálicas:
            </Text>
            <Box marginTop='8px'>
              <Table variant="simple" maxWidth='408px'>
                <Thead >
                  <Tr >
                    <S.ThStyled>Pórtico</S.ThStyled>
                    <S.ThStyled>Peso estimado</S.ThStyled>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <S.TdStyled>Terças e tirantes</S.TdStyled>
                    <S.TdStyled>0,05 KN/m² (5kgf/m²)</S.TdStyled>
                  </Tr>
                  <Tr>
                    <S.TdStyled>Contraventamentos</S.TdStyled>
                    <S.TdStyled>0,05 KN/m² (5kgf/m²)</S.TdStyled>
                  </Tr>
                  <Tr>
                    <S.TdStyled>Telhas</S.TdStyled>
                    <S.TdStyled>0,06 a 0,12 KN/m² (5kgf/m²)</S.TdStyled>
                  </Tr>
                </Tbody>
              </Table>
            </Box>
          </Flex>
          <Flex flexDirection={'column'}>
            <Text color="#101828" fontSize="14px" fontWeight="600">
              Ações Variáveis
            </Text>
            <Text color="#667085" fontSize="14px" fontWeight="600">
              Sobrecarga na cobertura 
            </Text>
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              0,25 KN/m² (5kgf/m²) - Segundo NBR 8800/08
            </Text>
            <Text color="#667085" fontSize="14px" fontWeight="600">
              Vento NBR6123/88 
            </Text>
            <Text color="#667085" fontSize="14px">
              Foram considerados dois casos de vento:
            </Text>
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              Para construção totalmente aberta
            </Text>
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              Para construção totalmente fechada, sem aberturas dominantes e com as quatro faces igualmente permeáveis
            </Text>
            <Text color="#667085" fontSize="14px">
              Foram considerados:
            </Text>
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              Velocidade básica do vento de 30, 35, 40 e 45m/s
            </Text>
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              Fator topográfico S1 = 1
            </Text>
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
            Fator de rugosidade S2 para categoria III e classe B
            </Text>
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              Fatos estatístico S3 = 1
            </Text>
            

          </Flex>
          <Flex flexDirection={'column'}>
            <Text color="#101828" fontSize="14px" fontWeight="600">
              Para dimensionsamento estrutural utilizam-se as seguintes combinações (cargas fatoradas):
            </Text>
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              1,3 x Ações permanentes
            </Text>
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              1,3 x Ações permanentes + 1,5 x Sobrecargas
            </Text>   
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              1,0 x Ações permanentes + 1,4 x Vento 
            </Text>   
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              1,3 x Ações permanentes + 1,5 Sobrecargas + 0,6 x 1,4 x Vento
            </Text>   
            <Text color="#667085" fontSize="14px" marginLeft='16px'>
              1,3 x Ações permanentes + 1,4 x Vento + 1,00 x 1,5 x Sobrecargas
            </Text>         
          </Flex>
        </ModalBody>
        <ModalFooter p="0" mt="32px">
          <Button w="192px" justifySelf={'flex-end'}  bgColor="#022D58" color="#fff" onClick={onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
